import { createAction } from '@reduxjs/toolkit';

import chatSlice from './slice';
import prepareActions from '../prepareActions';
import * as waitingActions from './actions/index';

export const chatActions = {
  ...chatSlice.actions,
  fetchMessages: createAction('chat/fetchMessages'),
  loadMoreMessages: createAction(
    'chat/loadMoreMessages',
    ({
      url, chatId, isNext, isPrev, isCustom,
    }) => ({
      payload: {
        url, chatId, isNext, isPrev, isCustom,
      },
    }),
  ),
  loadPrevMessages: createAction(
    'chat/loadPrevMessages',
    prepareActions.movePromiseToMeta,
  ),
  fetchChannels: createAction(
    'chat/fetchChannels',
  ),
  createChannel: createAction(
    'chat/createChannel',
    reportId => ({
      payload: reportId,
    }),
  ),
  sendData: createAction(
    'chat/sendData',
  ),
  debounceChat: createAction('chat/debounceChat', payload => ({
    payload,
  })),
  replaceData: createAction('chat/replaceData'),
  checkTokens: createAction('chat/checkTokens'),
  deleteChannel: createAction('chat/deleteChannel'),
  ...waitingActions,
  // INJECT
};
